(function (angular) {
    var MKioskService = (function () {
        var _this = this;

        function MKioskService($http, $q, $Config, Upload, $translationService, CacheMemoryService, $injector) {
            this.apiUrl = $Config.apiUrl;
            this.$http = $http;
            this.$q = $q;
            this.Upload = Upload;            
            this.$Config = $Config;
            this.$translationService = $translationService;
            this.cacheMemoryService = CacheMemoryService;
            this.$injector = $injector;


            this.lastCallGetDriverStats = null;
            this.lastDriverStats = null;
        }

        MKioskService.prototype = {
            getUrl: function (url) {
                return this.apiUrl + url;
            },
            getChargingPoints: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/chargingpoints")).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getDriverstats: function () {
                if (_this.lastCallGetDriverStats) {
                    // var diffDays = moment().startOf('day').diff(_this.lastCallGetDriverStats.startOf('day'), 'days');
                    // console.log('Get driver stats diff days: ', diffDays);
                    if (moment().diff(_this.lastCallGetDriverStats, 'days') < 1 && _this.lastDriverStats) {
                        // console.log('--- getDriverstats from cache');
                        return this.$q.resolve(_this.lastDriverStats);
                    } else {
                        delete this.lastCallGetDriverStats;
                        delete this.lastDriverStats;
                    }
                }

                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/getdriverstats")).then(function (response) {
                        _this.lastDriverStats = response.data;
                        _this.lastCallGetDriverStats = moment();
                        // console.log('--- getDriverstats from server', response.data);
                        resolve(response.data);
                    }, reject);
                }));

                /*
                   return this.$q(angular.bind(this, function (resolve, reject) {
                       this.$http.get("data/driverstats.json").then(function (response) {
                           resolve(response.data);
                       }, reject);
                   }));
                  */
            },
            getHomeScreenData: function() {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    let params = {};
                    // NF-821: Only add params if run on cordova
                    if(window.cordova){
                        params = {
                            Platform: ionic.Platform.isIOS() ? 'iOS' : 'Android',  // Platform: 'iOS','Android'(Default Android)
                            Version : this.$Config.getVersion() // ex: "2024.3.0"
                        }     
                    }
                    /** @type {AuthService} */
                    let authService = this.$injector.get('AuthService');
                    this.$http({
                        url: this.getUrl("mobile/GetHomeScreenData"),
                        method: "GET",
                        params: params
                    }).then((response)=> {
                        if(response.data && response.data.MustUpdatePasswordReason){
                            // NF-1246: Show ChangePassword dialog
                            /** @type {AuthService} */
                            let authService = this.$injector.get('AuthService');
                            authService.showChangePassword(response.data.MustUpdatePasswordReason);
                        } else {
                            // NF-821: Show UpdateRecommended dialog
                            if(window.cordova && response.data && response.data.UpdateRecommended){
                                authService.showUpdateRecommendedDialog(response.data.InstallationUrl);
                            }                     
                        }
                        resolve(response.data);
                    }, angular.bind(this,function(error){
                        // NF-821: Show "UpdateRequired dialog" if run on cordova and UpdateRequired is true
                        if(window.cordova && error && error.data && error.data.code==='UpdateRequired') {
                            authService.showUpdateRequiredDialog(error.data.data.InstallationUrl);
                            error.skipShowAPIError = true;
                        }
                        reject(error);
                    }));
                }));
            },
            resetDriverStatsCache: function() {
                // console.log('>>>>resetDriverStatsCache');
                delete _this.lastCallGetDriverStats;
                delete _this.lastDriverStats;
            },
            getHomeCharges: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/HomeCharge/GetHomeCharges")).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
                /*
                return this.$q(angular.bind(this, function (resolve, reject) {
                   this.$http.get("data/homecharges.json").then(function (response) {
                       resolve(response.data);
                   }, reject);
                }));
                */
            },
            getMyCharges: function (params) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/MyCharges/GetMyChargesData"), params).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
                /*
                return this.$q(angular.bind(this, function (resolve, reject) {
                   this.$http.get("data/homecharges.json").then(function (response) {
                       resolve(response.data);
                   }, reject);
                }));
                */
            },
            getMyChargesConsumptionForAllPeriods: function(type) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/MyCharges/GetConsumptionForAllPeriods"),{
                        params: {
                            type: type
                        }
                    }
                    ).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getDetailOfOngoingPeriod: function() {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/HomeCharge/GetDetailOfOngoingPeriod")).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
                /*
                return this.$q(angular.bind(this, function (resolve, reject) {
                   this.$http.get("data/homecharges.json").then(function (response) {
                       resolve(response.data);
                   }, reject);
                }));
                */
            },
            getConsumptionDetailsForPeriod: function(period, type) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/MyCharges/GetConsumptionDetailsForPeriod"),
                    {
                        params: {
                            period: period,
                            type: type
                        }
                    }).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));              
            },
            getEvents: function() {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/event/GetEvents"),{
                        params: {
                            language: this.$translationService.getCurrentLanguageCode()
                        }
                    }
                    ).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getEvent: function (eventId) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/event/GetEvent"), {
                        params: {
                            id: eventId, 
                            language: this.$translationService.getCurrentLanguageCode()
                        }
                    }).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            markEventAsRead: function (eventId) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/event/MarkEventAsRead"), {
                        id: eventId
                    }).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            adEventComment: function (data) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/event/AddEventComment"), data).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getEventTypes: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/event/GetEventTypes"), {
                        params: {
                            language: this.$translationService.getCurrentLanguageCode()
                        }
                    }).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            addEvent: function (data) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/event/AddEvent"), data).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            uploadFile: function (file) {
                var url = this.getUrl("mobile/UploadTempFile");
                url = url + "?filename=" + file.name;
                url = url + "&length=" + file.size;
                return this.Upload.upload({url: url, data: {pic: file}, method: 'POST'});
            },
            getClients: function (searchText) {
                let apiUrl = "mobile/event/GetClients";
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl(apiUrl), {
                        params: {
                            searchText: searchText
                        }
                    }).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
                
            },

            /**
             *
             * @returns {angular.IPromise<IVehicle[]>}
             */
            getMyVehicles: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {                    
                    this.$http.get(this.getUrl("mobile/GetMyVehicles")).then( (response)=> {
                        var vehicles = response.data||[];

                        // Format data
                        vehicles = vehicles.map(function (vehicle) {
                            vehicle.ChargeAtArrival = vehicle.ChargeAtArrival || 0;
                            vehicle.ChargeNeededAtDeparture = vehicle.ChargeNeededAtDeparture || 0;
                            vehicle.EstimatedCurrentCharge = vehicle.EstimatedCurrentCharge || 0;
                            vehicle.ChargeStatus = vehicle.ChargeStatus || 'Disconnected';

                            return vehicle;
                        });
                        this.cacheMemoryService.get("homepage").set('vehicles', vehicles);
                        resolve(vehicles);
                        
                    }, reject);
                }));
            },
            getMyHomeChargers: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {                    
                    this.$http.get(this.getUrl("mobile/GetMyHomeChargers")).then(function (response) {
                        var homecharges = response.data;
                        resolve(homecharges);
                        
                    }, reject);
                }));
            },
            hasMultiVehicle: function (vehicles) {
                var hasMultiVehicle = false;
                if (vehicles)
                    if (vehicles.length > 1)
                        hasMultiVehicle = true;
                return hasMultiVehicle;
            },
            setMemoryStorage: function (key, value) {
                if (!window.memoryStorage)
                    window.memoryStorage = {};
                window.memoryStorage[key] = value;
            },
            getMemoryStorage: function (key) {
                if (!window.memoryStorage)
                    window.memoryStorage = {};
                return window.memoryStorage[key];
            },
            getProfile: function (data) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/GetProfile")).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            updateProfile: function (data) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/UpdateProfile"), data).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            generatePass: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/UserAccount/GeneratePassword")).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            estimatePasswordStrength: function (newPassword) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/UserAccount/EstimatePasswordStrength"), {
                        NewPassword: newPassword
                    }).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            changePassword: function (data) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.post(this.getUrl("mobile/UserAccount/ChangePassword"), data).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getCurrentUser: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/UserAccount/GetCurrentUser")).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getMyFuelLimit: function() {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl('mobile/FuelLimit/GetMyFuelLimit')).then(function (response) {
                        resolve(response.data);
                    }, reject);
                }));
            },
            getEventVehicles: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/event/GetVehicles")).then(function (response) {
                        var vehicles = response.data;
                        resolve(vehicles);
                    }, reject);
                }));
            },
            getInputLanguages: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    this.$http.get(this.getUrl("mobile/Input/Language"), {
                        params: {
                            startIndex: 0,
                            pageSize: 1000,
                            language: this.$translationService.getCurrentLanguageCode()
                        }
                    }).then(function (response) {
                        resolve(response.data.Rows || []);
                    }, reject);
                }));
            },

            refreshMyVehicles: function(){
                return this.getMyVehicles();
            },

            /**
             * 
             * @param data
             * @returns {angular.IPromise}
             */
            inputMileage(data){
                return this.$http.post(this.getUrl("mobile/RequiredAction/InputMileage"), data).then((response) =>{
                    return response.data;
                });
            }
        };
        return MKioskService;
    }());
    angular.module('shared').service('MKioskService', ['$http', '$q', '$Config', 'Upload', '$translationService','CacheMemoryService','$injector', MKioskService]);
}(angular));
